export const API = {
  baseUrl: "https://api.graberweine-messen.ch",
  key: "074727580aee5a80d5f3de24c3dc9a",
  form: "Weinbestellung",
};
